import { EvoReedyEventType, EvoRemoteWebhook } from '../../services/firebaseFunctions';

export const REEDY_EVO_EVENT_TYPES: readonly EvoReedyEventType[] = ['NewSale', 'RecurrentSale', 'ClearedDebt'];

/** Mesma ideia do backend: evento Reedy + callback `evoWebhookHandler` com `?id=<empresa>`. */
export function isReedyManagedEvoWebhook(webhook: EvoRemoteWebhook, companyId: string): boolean {
  if (!REEDY_EVO_EVENT_TYPES.includes((webhook.eventType || '') as EvoReedyEventType)) return false;
  try {
    const url = new URL(webhook.urlCallback);
    if (!url.pathname.includes('evoWebhookHandler')) return false;
    return url.searchParams.get('id') === companyId;
  } catch {
    return false;
  }
}

export type EvoWebhookRowStatus = 'created' | 'missing' | 'duplicate';

export interface EvoWebhookEventRow {
  eventType: EvoReedyEventType;
  status: EvoWebhookRowStatus;
  /** ID do webhook na EVO (ausente em "Faltando"). */
  id?: string;
}

export interface EvoWebhookAnalysis {
  /** Webhooks Reedy da empresa encontrados na lista da EVO. */
  reedy: EvoRemoteWebhook[];
  /** Uma linha por evento esperado; cópias extras do mesmo evento viram linhas "Duplicado". */
  rows: EvoWebhookEventRow[];
  createdEvents: EvoReedyEventType[];
  missingEvents: EvoReedyEventType[];
  duplicateEvents: Array<{ eventType: EvoReedyEventType; count: number }>;
}

/** Deriva o estado por evento (Criado / Faltando / Duplicado) da lista devolvida pela EVO. */
export function analyzeReedyWebhooks(list: EvoRemoteWebhook[], companyId: string | undefined | null): EvoWebhookAnalysis {
  const reedy = companyId ? list.filter((webhook) => isReedyManagedEvoWebhook(webhook, companyId)) : [];
  const rows: EvoWebhookEventRow[] = [];
  const createdEvents: EvoReedyEventType[] = [];
  const missingEvents: EvoReedyEventType[] = [];
  const duplicateEvents: EvoWebhookAnalysis['duplicateEvents'] = [];

  REEDY_EVO_EVENT_TYPES.forEach((eventType) => {
    const copies = reedy.filter((webhook) => webhook.eventType === eventType);
    if (copies.length === 0) {
      missingEvents.push(eventType);
      rows.push({ eventType, status: 'missing' });
      return;
    }
    createdEvents.push(eventType);
    copies.forEach((webhook, index) => {
      rows.push({ eventType, status: index === 0 ? 'created' : 'duplicate', id: String(webhook.id) });
    });
    if (copies.length > 1) duplicateEvents.push({ eventType, count: copies.length });
  });

  return { reedy, rows, createdEvents, missingEvents, duplicateEvents };
}
